import { useOrganisationsContext } from '@/context/OrganisationsContext';

export const useCanManageSubscription = () => {
    const { userOrganisation } = useOrganisationsContext();

    return userOrganisation?.owner;
};
